import { useEffect, useState} from 'react'
import Template from './../../Template'
import * as SG from '../../../style/Styles'
import * as S from '../../../style/User'
import * as TXT from './../../../util/Texts'
import { useNavigate } from 'react-router-dom'
import UserTable from './../../../components/table/UserTable'
import { IUser } from '../../../interfaces/IUser'
import * as UserService from './../../../services/User.service'
import Swal from 'sweetalert2'
import * as XLSX from 'xlsx'
import { ERROR_ALERT, SUCCESS_ALERT } from './../../../util/AlertsMsg'

export default function Users() {

  const navigate              = useNavigate()
  const [users, setUsers]     = useState<IUser[]>([])
  const [nameF, setNameF]     = useState<string>('')
  const [cs, setCs]           = useState<string>('')
  const [countryId, setCountryId] = useState<string>('')
  const [deptF, setDeptF]         = useState<string>('')
  const [plants, setPlants]   = useState<string[]>([])
  const [countries, setCountries] = useState<any[]>([])
  const [departments, setDepartments] = useState<string[]>([])

  // PAGINATION STATES
  const [page, setPage]       = useState<number>(1)
  const [total, setTotal]     = useState<number>(0)
  const limit                 = 50

  const getCs = async () => {

    const result = await UserService.GetCs()
  
    if (result.data && result.data.status) 
      setPlants(result.data.plants)

    return
  }

  const getDepartments = async () => {
    const result = await UserService.GetDepartments()
    if (result.data && result.data.status) 
      setDepartments(result.data.departments)
    return
  }
  
  const getAllUsers = async (targetPage: number = page) => {

    const filter:any = {
      name: nameF, 
      plant: cs, 
      country_id: countryId, 
      department: deptF,
      limit: limit,
      page: targetPage
    }
    const result     = await UserService.GetAllUsers(filter)

    if (result.data) {
      setUsers(result.data.users)
      setTotal(result.data.total || 0)
    }
    
    return
  }

  const filter = async () => {
    setPage(1)
    getAllUsers(1)
    return
  }

  useEffect(()=>{

    getCs()
    getDepartments()
    const storedCountries = localStorage.getItem('app_countries')
    if (storedCountries) {
      setCountries(JSON.parse(storedCountries))
    }
    getAllUsers(1)
    
  }, [])

  const handleImportExcel = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    const file = files[0];
    const reader = new FileReader();

    reader.onload = async (evt) => {
      try {
        const bstr = evt.target?.result;
        const wb = XLSX.read(bstr, { type: 'binary' });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        
        const data = XLSX.utils.sheet_to_json(ws, { header: 1 }) as any[][];
        
        if (data.length <= 1) {
          ERROR_ALERT('A planilha está vazia ou contém apenas o cabeçalho!');
          return;
        }

        const usersToImport: any[] = [];
        
        for (let i = 1; i < data.length; i++) {
          const row = data[i];
          if (!row || row.length === 0) continue;
          
          const name = row[0] ? String(row[0]).trim() : '';
          const register = row[1] ? String(row[1]).trim() : '';
          const cs = row[2] ? String(row[2]).trim() : '';
          const department = row[3] ? String(row[3]).trim() : '';
          const country_sigla = row[4] ? String(row[4]).trim() : '';

          if (name && register) {
            usersToImport.push({
              name,
              register,
              cs,
              department,
              country_sigla
            });
          }
        }

        if (usersToImport.length === 0) {
          ERROR_ALERT('Nenhum usuário válido encontrado na planilha. Verifique se o nome e registro estão preenchidos.');
          return;
        }

        Swal.fire({
          title: 'Importar usuários',
          text: `Deseja importar os ${usersToImport.length} usuários encontrados na planilha?`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim, importar',
          cancelButtonText: 'Cancelar'
        }).then(async (result) => {
          if (result.isConfirmed) {
            Swal.showLoading(null);
            const res = await UserService.ImportUsers({ users: usersToImport });
            if (res && res.data && res.data.status) {
              SUCCESS_ALERT(res.data.message);
              getAllUsers();
            } else {
              ERROR_ALERT(res.data?.message || 'Erro ao realizar a importação!');
            }
          }
        });

      } catch (err) {
        console.error(err);
        ERROR_ALERT('Erro ao ler a planilha. Certifique-se de que o arquivo está no formato correto.');
      }
    };

    reader.readAsBinaryString(file);
    e.target.value = '';
  };
  
  return (

    <Template>
      
      <SG.Title style={{textAlign:'center'}}>{TXT.USERS}</SG.Title>

      <SG.Flex className='filtersContent'>
        <SG.Input 
          className='inputFilter' 
          type="text" 
          placeholder={TXT.SEACH_USER}
          onChange={(e)=>{setNameF(e.target.value)}} 
          value={nameF} 
          style={{height:46}}
        />

        <SG.Select 
          className='inputFilter' 
          placeholder={TXT.FILTER_BY_PLANT} 
          onChange={(e)=> {setCs(e.target.value)}} 
          value={cs}
        >
          <SG.Option value="">{TXT.FILTER_BY_PLANT}</SG.Option>
          { plants.length && plants.map((p:string, i:number) => (
              <SG.Option key={i} >{p}</SG.Option>
          ))}
        </SG.Select>

        <SG.Select 
          className='inputFilter' 
          onChange={(e)=> {setDeptF(e.target.value)}} 
          value={deptF}
        >
          <SG.Option value="">Filtrar por Departamento</SG.Option>
          { departments.length && departments.map((d:string, i:number) => (
              <SG.Option key={i} value={d}>{d}</SG.Option>
          ))}
        </SG.Select>

        <SG.Select 
          className='inputFilter' 
          onChange={(e)=> {setCountryId(e.target.value)}} 
          value={countryId}
        >
          <SG.Option value="">Filtrar por País</SG.Option>
          { countries.length && countries.map((c:any, i:number) => (
              <SG.Option key={i} value={c.id}>{c.name}</SG.Option>
          ))}
        </SG.Select>

        <SG.Span className='incoFilter' onClick={filter}><SG.I className="fa-solid fa-magnifying-glass"></SG.I></SG.Span>

        <label htmlFor="import-excel-file" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
          <SG.Span className='incoFilter' style={{ color: '#fff', marginLeft: '5px' }} title="Importar planilha de usuários">
            <SG.I className="fa-solid fa-file-excel"></SG.I>
          </SG.Span>
        </label>
        <input 
          id="import-excel-file"
          type="file"
          accept=".xlsx, .xls"
          style={{ display: 'none' }}
          onChange={handleImportExcel}
        />
      </SG.Flex>

      <SG.PADD>
        <SG.Div className='boxUsers'>
          <UserTable 
            data={users} 
            page={page} 
            total={total} 
            limit={limit} 
            onPageChange={(newPage) => {
              setPage(newPage)
              getAllUsers(newPage)
            }} 
          />
        </SG.Div>
      </SG.PADD>

      <S.BtnNew className='btnPlusUser' onClick={ () => { navigate(`/users-form/`) }}> <i className="fa-solid fa-plus"></i> {TXT.NEW}</S.BtnNew>
    </Template>
  );
}
  